<float-ui-content class="ngxp__tooltip" [ngClass]="cssClass">
    @if (closeType === 'button') {
        <vn-icon name="theme-ex" extraClass="ui-icon ui-close" (click)="close()" size="12" />
    }
    <div [ngClass]="cssTextClass">
        <ng-content select="[content]" />
    </div>
    <div class="popper-buttons">
        <ng-content select="[buttons]" />
        @if (closeType === 'link') {
            <div class="ngxp__close-link">
                <span class="popper-close-link dh" (click)="close()">
                    {{ closeLinkText || commonMessages?.PopoverCloseText }}
                </span>
            </div>
        }
    </div>
</float-ui-content>
